import React, { useState } from "react";
import axios from "axios";

import { InputContainer, Modal, Button } from "components/common";
import { modalBGColor } from "utils/customStyles";
import SuccessMessage from "components/Popups/Messages/SuccessMessage";

const ApproveUserModal = ({ isOpen, close, user }) => {
  const [success, setSuccess] = useState(false);
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [creditLimit, setCreditLimit] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async () => {
    if (!creditLimit || !notes) {
      setErrorMessage("Please enter a spending power and notes.");
      return;
    }

    const jwt = window.localStorage.getItem("jwt");

    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/v2/getDecision`,
      {
        userId: user.email,
        creditLimit,
        forceApprove: true,
        notes
      },
      {
        headers: { Authorization: `Bearer ${jwt}` }
      }
    );

    if (data.success === false) {
      setErrorMessage(data.error_message);
      setLoading(false);
      console.log(data);
      return;
    }
    setLoading(false);
    setSuccess(true);
  };

  const WIDTH384 = { width: "384px" };
  const WIDTHANDBORDER = { width: "384px", border: "1px solid #e2e8f0" };

  return (
    <Modal isOpen={isOpen} close={close}>
      {success ? (
        <SuccessMessage mainMessage="You have successfully approved the user." />
      ) : (
        <div
          className="bg-white flex flex-col justify-center items-center"
          style={{ ...modalBGColor, width: "500px" }}
        >
          <div className="bg-green text-white text-xl py-3 px-3">
            <p>Terminate User</p>
          </div>
          <div style={WIDTH384} className="text-2xl mb-2">
            Spending Power:
          </div>
          <InputContainer style={WIDTHANDBORDER} className="bg-white">
            <input
              type="number"
              value={creditLimit}
              className="bg-white outline-none w-full text-green-primary ml-1"
              placeholder="Spending Power"
              onChange={e => {
                setLoading(false);
                setErrorMessage("");
                setCreditLimit(parseInt(e.target.value, 10));
              }}
            />
          </InputContainer>
          <div style={WIDTH384} className="text-2xl my-2">
            Notes:
          </div>
          <textarea
            style={WIDTHANDBORDER}
            onChange={e => {
              setLoading(false);
              setErrorMessage("");
              setNotes(e.target.value);
            }}
          />
          <div
            style={WIDTH384}
            className={errorMessage ? "text-red-600 mb-4" : "hidden"}
          >
            {errorMessage}
          </div>
          <Button
            className={`mt-5 text-2xl btn-green mb-8 ${
              loading ? "opacity-50" : ""
            }`}
            disabled={loading}
            onClick={() => {
              setLoading(true);
              handleSubmit();
            }}
          >
            Approve
          </Button>
        </div>
      )}
    </Modal>
  );
};

export default ApproveUserModal;
